export const price = {
  methods: {
    formatPrice (amount) {
      if (!amount) {
        amount = 0
      }

      const c = amount.toLocaleString('uk-UK', {
        style: 'currency',
        currency: 'UAH'
      })

      return c.replace('грн', '')
    },

    formatPriceWithCurrency (amount) {
      if (!amount) {
        amount = 0
      }

      return amount.toLocaleString('uk-UK', {
        style: 'currency',
        currency: 'UAH'
      })
    }
  }
}
